import React from "react";
import List from "@mui/material/List";
import AccordionItem from "./AccordionItem";
import routes from '../../routes';

export const Accordion = () => {
    return (
        <List component="nav">
            {routes.sidebarRoutes.map((item, i) => (
                <AccordionItem {...item} key={i} />
            ))}
        </List>
    );
};

export default Accordion;